const Calendar = {
  getCalendar: `/Trips/GetMinimumPrice`,
};

export default Calendar;
